import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private renderer: Renderer2;
  private _theme$ = new BehaviorSubject<Theme>(this.getSavedTheme());

  theme$ = this._theme$.asObservable();

  get isDark(): boolean { return this._theme$.value === 'dark'; }

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.apply(this._theme$.value);
  }

  toggle(): void {
    const next: Theme = this._theme$.value === 'light' ? 'dark' : 'light';
    this.apply(next);
  }

  private apply(theme: Theme): void {
    this.renderer.setAttribute(document.documentElement, 'data-theme', theme);
    localStorage.setItem('theme', theme);
    this._theme$.next(theme);
  }

  private getSavedTheme(): Theme {
    const saved = localStorage.getItem('theme') as Theme | null;
    if (saved === 'dark' || saved === 'light') return saved;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
}
